import React, { PropTypes } from 'react';
import AnimateOnChange from 'react-animate-on-change';
import Field from '../../common/Field/Field';
import './TextField.less';

class TextField extends Field {
  render () {
    const {label, placeholder, autoFocus, value, type, onChange} = this.props;
    const {animateError} = this.state;

    return (
      <AnimateOnChange
          baseClassName="input-field text-field"
          animationClassName="shake--active"
          animate={animateError}>
        {label && (<label>{label}</label>)}
        <input type={type} value={value} placeholder={placeholder} autoFocus={autoFocus} onChange={e => {onChange && onChange(e.target.value);}}/>
      </AnimateOnChange>
    );
  }
}

TextField.defaultProps = {
  type: 'text'
};

TextField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  onChange: PropTypes.func
};

export default TextField;



// WEBPACK FOOTER //
// ./src/components/common/TextField/TextField.js